import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./src/assets/styles/common/toast.scss";
import { AuthProvider } from './src/contexts/AuthContext';
import AppRoutes from './src/routes/AppRoutes';
import Spinner from './src/components/common/Spinner';
import Preloader from './src/components/common/Preloader';
import ThemeProvider from './src/context/ThemeProvider';
import MaintenanceScreen from './src/components/common/MaintenanceScreen';

const MAINTENANCE_MODE = true;

// Global loading component for suspense fallback
const GlobalLoader = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <Spinner size="large" fullPage={true} />
  </div>
);

const App = () => {
  if (MAINTENANCE_MODE) {
    return (
      <ThemeProvider>
        <MaintenanceScreen />
      </ThemeProvider>
    );
  }

  return (
    <>
      <Preloader />
      <Suspense fallback={<GlobalLoader />}>
      <ThemeProvider>
        <AuthProvider>
          <Router>
            <AppRoutes />
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="colored"
              closeButton={false}
              draggablepercent={80}
            />
          </Router>
        </AuthProvider>
        </ThemeProvider>
      </Suspense>
    </>
  );
};

export default App;
